export class StoragePath {
  /***************************************************************************
   *                                                                         *
   * Static fields                                                           *
   *                                                                         *
   **************************************************************************/

  public static readonly DELIMITER = '/'

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _elements: string[]

  /***************************************************************************
   *                                                                         *
   * Static methods                                                          *
   *                                                                         *
   **************************************************************************/

  public static of(elements: string[]): StoragePath {
    return new StoragePath(elements)
  }

  public static parse(pathStr: string): StoragePath {
    if (pathStr === null) {
      // TODO: this would be handled below?
      throw Error('path was null!')
    }

    let path: StoragePath

    if (!pathStr) {
      path = new StoragePath([])
    } else {
      path = new StoragePath(pathStr.split(this.DELIMITER))
    }

    return path
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(elements: string[]) {
    this._elements = elements
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get elements(): string[] {
    return this._elements
  }

  public get isEmpty(): boolean {
    return !this.elements || this.elements.length === 0
  }

  public get level(): number {
    return !this.isEmpty ? this.elements.length : 0
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public isSubPathOfPath(path: StoragePath): boolean {
    return this.isSubPathOfPathString(path.serialize())
  }

  public isSubPathOfPathString(path: string): boolean {
    return this.serialize().startsWith(path)
  }

  public serialize(): string {
    if (!this.isEmpty) {
      return this.elements.join(StoragePath.DELIMITER).toUpperCase()
    } else {
      return ''
    }
  }
}
